import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/logo.jpg';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import './PublicShell.css';

/**
 * Marco público: barra superior y pie compartidos por todas las pantallas a
 * las que se llega sin haber iniciado sesión.
 *
 * Existe para que entrar a la aplicación no sea caer en una pantalla suelta.
 * El acceso, el registro, la confirmación de correo y el cambio de contraseña
 * viven todos dentro del mismo sitio, con la misma navegación y el mismo pie.
 *
 * Sólo enlaza a lo que existe de verdad: la página de información y sus
 * secciones, el acceso y el registro. Nada de páginas inventadas para rellenar.
 */

const year = new Date().getFullYear();

export default function PublicShell({ children, wide = false }) {
  /* La barra ofrece siempre la puerta que le falta a quien está mirando: en
     información, las dos; dentro del acceso, sólo el registro; dentro del
     registro, sólo el acceso. Repetir el botón de la pantalla en la que ya
     estás no es navegación, es ruido. */
  const { pathname } = useLocation();
  const enAcceso = pathname === '/login';
  const enRegistro = pathname === '/register';

  return (
    <div className="ng-public">
      <header className="ng-public__bar">
        <div className="ng-public__bar-inner">
          <Link to="/info" className="ng-public__brand" aria-label="NisaGuard, inicio">
            <span
              className="ng-public__mark"
              style={{ backgroundImage: `url(${logo})` }}
              aria-hidden="true"
            />
            <span className="ng-public__wordmark">NisaGuard</span>
          </Link>

          <nav className="ng-public__nav" aria-label="Navegación del sitio">
            <a className="ng-public__link" href="/info#about">Nosotros</a>
            <a className="ng-public__link" href="/info#products">Soluciones</a>
            <a className="ng-public__link" href="/info#contact">Contacto</a>
          </nav>

          <div className="ng-public__actions">
            <ThemeToggle />
            {!enRegistro && (
              <Link
                to="/register"
                className="ng-btn ng-btn--ghost ng-btn--sm ng-public__cta"
              >
                Crear cuenta
              </Link>
            )}
            {!enAcceso && (
              <Link to="/login" className="ng-btn ng-btn--primary ng-btn--sm">
                Acceder
              </Link>
            )}
          </div>
        </div>
      </header>

      <main className={`ng-public__main ${wide ? 'is-wide' : ''}`}>{children}</main>

      {/* El ancla #contact vive aquí: los datos de contacto son estos y no hay
          una página aparte que inventarse. */}
      <footer className="ng-public__footer" id="contact">
        <div className="ng-public__footer-inner">
          <div className="ng-public__footer-brand">
            <span className="ng-public__brand">
              <span
                className="ng-public__mark"
                style={{ backgroundImage: `url(${logo})` }}
                aria-hidden="true"
              />
              <span className="ng-public__wordmark">NisaGuard</span>
            </span>
            <p className="ng-public__footer-desc">
              Medición y control de agua para instalaciones domésticas y
              comerciales. Nuevo León, México.
            </p>
          </div>

          <nav className="ng-public__footer-col" aria-label="Producto">
            <h2 className="ng-public__footer-title">Producto</h2>
            <a href="/info#products">NisaMeter</a>
            <a href="/info#about">Sobre NisaGuard</a>
            <Link to="/login">Acceder a la plataforma</Link>
            <Link to="/register">Crear cuenta</Link>
          </nav>

          <div className="ng-public__footer-col">
            <h2 className="ng-public__footer-title">Contacto</h2>
            <a href="mailto:nisaguard@outlook.com">nisaguard@outlook.com</a>
            <span>Nuevo León, México</span>
          </div>

          <div className="ng-public__footer-col">
            <h2 className="ng-public__footer-title">Redes</h2>
            <a href="https://www.facebook.com/NisaGuard" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href="https://instagram.com/nisaguard" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://www.tiktok.com/@nisaguard" target="_blank" rel="noopener noreferrer">TikTok</a>
          </div>
        </div>

        <div className="ng-public__footer-bottom">
          <span>&copy; {year} NisaGuard. Todos los derechos reservados.</span>
        </div>
      </footer>
    </div>
  );
}
